import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaBath } from "react-icons/fa";
import { LuBedDouble } from "react-icons/lu";
import { BiArea } from "react-icons/bi";
import axios from "axios";
import "./Propertylist.css";

const Propertylist = () => {
  const [properties, setProperties] = useState([]);
  const navigate = useNavigate();

  const user = JSON.parse(localStorage.getItem("user"));
  const isAdmin = user?.role === "admin";

  useEffect(() => {
    axios
      .get("https://baseapis.akari.sa/api/Property/GetProperties")
      .then((res) => setProperties(res.data))
      .catch((err) => console.error("Error fetching properties:", err));
  }, []);

 const handleDelete = async (id) => {
  const confirmDelete = window.confirm("Are you sure you want to delete this property?");
  if (!confirmDelete) return;



  try {
    const response = await axios.post(
      `https://baseapis.akari.sa/api/Property/DeletePropertyById`, 
      '',  // Body data is empty as per your cURL example
      {
        params: {
          id: id  // Pass the ID as a query parameter
        }
      }
    );

    if (response.data.success) {
      setProperties(properties.filter((p) => p.id !== id)); // Remove the deleted property from the list
    } else {
      alert("Failed to delete property. " + response.data.message);
    }
  } catch (err) {
    console.error("Failed to delete property:", err);
    alert("Failed to delete property. Please try again.");
  }
};
return (
    <div className="property-list">
      {properties.map((property) => (
        <div
          key={property.id}
          className="property-card"
          onClick={() => {
            if (property?.id) {
              navigate(`/propertydetail/${property.id}`);
            } else {
              console.warn("Invalid property ID:", property);
            }
          }}
        >
          <img
            src={property.image[0] || "/placeholder.jpg"}
            alt="Property"
            className="property-image"
          />
          <div className="property-content">
            <h3 className="property-title">{property.title}</h3>
            <p className="property-description">{property.description}</p>
            <div className="property-details">
              <span>
                {property.bedroomNumber} <LuBedDouble className="card-icon" />
              </span>
              <span>
                {property.bathroomNumber} <FaBath className="card-icon" />
              </span>
              <span>
                {property.propertySize} m² <BiArea className="card-icon" />
              </span>
            </div>
            <div className="property-price">
              <span>{property.price} ﷼</span>
            </div>

            {isAdmin && (
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  handleDelete(property.id);
                }}
                className="delete-button"
              >
                Delete
              </button>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Propertylist;
